module.exports = __webpack_public_path__ + "img/hr-tree-08-e-trunk.b3c0f5d2.png";